import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FaFilter } from "react-icons/fa";

const BackLogFilter = ({ columns, filterByPriorityHandler, column_id }) => {
  const [filterId, setFilterId] = useState([]);
  const [showBackLogFilter, setShowBackLogFilter] = useState(false);
  const [options, setOptions] = useState([]);
  const [priorityId, setPriorityId] = useState([]);
  const [popwidthandhight, setPopwidthAndHight] = useState({
    screenX: "",
    screenY: 0,
    arrow: "",
  });
  const refss = useRef(null);

  useEffect(() => {
    const options =
      columns.find((item) => item.attribute_type === "priority")?.options ?? [];
    setOptions(options);
    setPriorityId(options.map((item) => item._id));
  }, [columns]);

  const showBackLogFilterHandler = (evt) => {
    setPopwidthAndHight({
      screenX:
        evt.pageX + 150 > window.innerWidth ? evt.pageX - 120 : evt.pageX,
      arrow: evt.pageX + 150 > window.innerWidth ? true : "",
      screenY: evt.pageY + 15,
    });
    setShowBackLogFilter(true);
  };
  useEffect(() => {
    const checkTarget = (e) => {
      if (refss.current && !refss.current.contains(e.target)) {
        // If clicked outside the div, hide it
        setShowBackLogFilter(false);
      }
    };

    document.addEventListener("mousedown", checkTarget);

    return () => {
      document.removeEventListener("mousedown", checkTarget);
    };
  }, []);

  const filterChangeHandler = (evt, id) => {
    console.log(id, 876535673433);
    let optionsId = [...priorityId];
    if (priorityId.includes(id)) {
      optionsId = optionsId.filter((it) => it !== id);
    } else {
      optionsId.push(id);
    }

    setPriorityId(optionsId);
    // const { value, checked } = evt.target;
    // let filtersIds = [...filterId];

    // if (checked) {
    //   if (!filtersIds.includes(id)) {
    //     filtersIds.push(id);
    //     setFilterId(filtersIds);
    //   }
    // } else {
    //   if (filtersIds.includes(id)) {
    //     filtersIds = filtersIds.filter((item) => item !== id);
    //     setFilterId(filtersIds);
    //   }
    // }

    filterByPriorityHandler(optionsId, column_id);
  };

  const getFiltersUI = () => {
    return createPortal(
      <ul
        className={`backlog_filters ${popwidthandhight.arrow ? "add-abs" : ""}`}
        style={{
          position: "absolute",
          left: popwidthandhight.screenX,
          top: popwidthandhight.screenY,
        }}
        ref={refss}
      >
        {options.map((opt) => (
          <li className="option-filter-kanban">
            <input
              type="checkbox"
              name=""
              checked={priorityId.includes(opt._id)}
              className="form-check-input"
              id={opt._id}
              onClick={(evt) => filterChangeHandler(evt, opt._id)}
            />{" "}
            <label htmlFor={opt._id}> {opt.name || opt.option_name}</label>
          </li>
        ))}
      </ul>,
      document.body
    );
  };

  return (
    <div>
      <FaFilter size={12} onClick={showBackLogFilterHandler} />
      {showBackLogFilter && getFiltersUI()}
    </div>
  );
};

export default BackLogFilter;
